
export const SLIDER_SPACING_DESKTOP = 20;
export const SLIDER_SPACING_TABLET = 24;
export const SLIDER_SPACING_MOBILE = 16;
export const MAX_SLIDES_DESKTOP = 4;
export const CENTER = 'center';
export const COVER='cover';
export const fontWeightMap: Record<string, string> = {
  light: 'font-light',
  regular: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
};

export const fontStyleMap: Record<string, string> = {
  light: 'text-light',
  regular: 'text-regular',
  medium: 'text-medium',
  semibold: 'text-semibold',
  bold: 'text-bold',
};

